// extracted by mini-css-extract-plugin
export default {"info":"OrganisationAffiliationStep_info__iPnzO","content":"OrganisationAffiliationStep_content__p5QpN"};